import React from 'react'

export default Component => {
  return class extends React.Component {
    state = {
      dirUp: false,
      dirDown: false,
      top: 0
    }

    componentDidMount() {
      window.addEventListener('scroll', this.handleScroll, false)
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll, false)
    }

    handleScroll = e => {
      this.setState(
        prevState => ({
          dirUp: window.scrollY < this.lastScroll,
          dirDown: window.scrollY > this.lastScroll,
          top: window.scrollY
        }),
        () => this.lastScroll = window.scrollY
      )
    }

    render() {
      return <Component scroll={this.state} {...this.props} />
    }
  }
}